import React, { useState, useContext, useEffect } from "react";
import LayoutWrapper from "../components/LayoutWrapper";
import HeaderBar from "../components/HeaderBar";
import { FaPrint, FaSearch, FaSms } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { ThemeContext } from "../context/ThemeContext";
import getCurrentSkin from "../utils/getCurrentSkin";

const LedgerSubReport = () => {
  const { isDark, skin } = useContext(ThemeContext);
  const currentSkin = getCurrentSkin(skin);

  const [filterType, setFilterType] = useState("Period"); // radio selection
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [voucher, setVoucher] = useState("");
  const [supplierCode, setSupplierCode] = useState("");
  const [supplierData, setSupplierData] = useState(null);
  const [data, setData] = useState([]);

  // 🔹 Retrieve supplier row from localStorage
  useEffect(() => {
    const saved = localStorage.getItem("ledgerSupplier");
    if (saved) {
      const parsed = JSON.parse(saved);
      setSupplierData(parsed);
      setSupplierCode(parsed.Code || parsed.fld_supplierid || "");
    }
  }, []);

  // 🔹 Search button handler
  const handleSearch = async () => {
    if (!supplierCode) {
      toast.error("Supplier is missing!");
      return;
    }

    const payload = {
      supplierCode: supplierCode,
      from: fromDate,
      to: toDate,
      branch: "8",
      
    };

    console.log("📤 Sending payload:", payload);

    try {
      const res = await axios.get(
        "https://www.nissi-india.com/api/grnSupplier_ledgerInside",
        { params: payload }
      );
      console.log("response:", res.data);
      setData(res.data.data || []);
    } catch (error) {
      console.error("❌ Error fetching data:", error);
      toast.error("Failed to fetch Ledger Sub Report");
    }
  };

  // 🔹 Handle Send SMS button
  const handleSendSms = (row) => {
    toast.success(`SMS sent for Invoice ${row.invNo}`);
    // here you can add API call to send SMS
  };

   const handlePrint = () => {
    const payload = {
      supplierCode: supplierCode,
      from: fromDate,
      to: toDate,
      branch: "8",
      
    };
      const query = new URLSearchParams(payload).toString();

  // open report page in new tab/window
  window.open(`/inventory/LedgerSubReport-Print?${query}`, "_blank");
  };

  return (
    <LayoutWrapper>
      <HeaderBar title="Ledger Sub Report" />

      <div className="p-4">
        {/* 🔹 Filter Section */}
        <div className="flex flex-col">
            <label>Filter Type</label>
            <div className="flex gap-4 mt-1">
              <label className="flex items-center gap-1">
                <input
                  type="radio"
                  value="Period"
                  checked={filterType === "Period"}
                  onChange={(e) => setFilterType(e.target.value)}
                />
                Period
              </label>
              <label className="flex items-center gap-1">
                <input
                  type="radio"
                  value="MonthWise"
                  checked={filterType === "MonthWise"}
                  onChange={(e) => setFilterType(e.target.value)}
                />
                Month Wise
              </label>
            </div>
          </div>
       <div className="grid grid-cols-2 gap-6 mb-4">
        <div className="space y-4">
          <div>
            <label>From Date</label>
            <input
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
              className="w-full border px-2 py-1"
            />
          </div>
          <div>
            <label>To Date</label>
            <input
              type="date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
              className="w-full border px-2 py-1"
            />
          </div>
          </div>
           
        <div className="space y-4">
          <div>
            <label>Voucher</label>
            <input
              type="text"
              value={voucher}
              onChange={(e) => setVoucher(e.target.value)}
              className="w-full border px-2 py-1"
            />
          </div>
          
          <div>
            <label>Supplier</label>
            <input
              type="text"
              value={supplierCode}
              readOnly
              className="w-full border px-2 py-1 bg-gray-100"
            />
          </div>
        </div>
        </div>

        {/* 🔹 Search Button */}
        <div className="flex justify-center mb-4 gap-5">
          <button
            onClick={handleSearch}
            className="bg-blue-600 text-white px-4 py-2 rounded flex items-center"
          >
            <FaSearch className="mr-2" /> Search
          </button>
           <button
            onClick={handlePrint}
            className="bg-green-600 text-white px-4 py-2 rounded flex items-center"
          >
            <FaPrint className="mr-2" /> Print
          </button>
        </div>

        {/* 🔹 Results Table */}
        <div className="border rounded overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-gray-200">
              <tr>
                <th className="border px-2 py-1">S.No</th>
                <th className="border px-2 py-1">Inv Date</th>
                <th className="border px-2 py-1">Inv No</th>
                <th className="border px-2 py-1">Credit</th>
                <th className="border px-2 py-1">Debit</th>
                <th className="border px-2 py-1">Cl. Balance</th>
                <th className="border px-2 py-1">Send SMS</th>
              </tr>
            </thead>
            <tbody>
              {data.length > 0 ? (
                data.map((row, idx) => (
                  <tr key={idx}>
                    <td className="border px-2 py-1">{idx + 1}</td>
                    <td className="border px-2 py-1">{row.fld_InvoiceDate}</td>
                    <td className="border px-2 py-1">{row.invno}</td>
                    <td className="border px-2 py-1 text-right">
                      {row.Credit_New
}
                    </td>
                    <td className="border px-2 py-1 text-right">
                      {row.Debit_New}
                    </td>
                    <td className="border px-2 py-1 text-right">
                      {row.
Cl_Balance_New
}
                    </td>
                    <td className="border px-2 py-1 text-center">
                      <button
                        onClick={() => handleSendSms(row)}
                        className="bg-green-600 text-white px-2 py-1 rounded flex items-center gap-1"
                      >
                        <FaSms /> Send
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center py-2">
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <ToastContainer />
    </LayoutWrapper>
  );
};

export default LedgerSubReport;
